import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideClientHydration, BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {NgOptimizedImage, provideImageKitLoader, registerLocaleData} from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import localeNl from '@angular/common/locales/nl';
import { GoogleMapsModule } from '@angular/google-maps';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';

import { GalleryModule } from '@ks89/angular-modal-gallery';

import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

registerLocaleData(localeNl, 'nl-NL');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
        anchorScrolling: "enabled"
      })
    ),

    // Hydration
    provideClientHydration(),

    // i18n
    { provide: LOCALE_ID, useValue: 'nl-NL' },

    // Firebase
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),

    // HTTP
    provideHttpClient(withInterceptorsFromDi()),

    // ImageKit
    provideImageKitLoader('https://ik.imagekit.io/steddie/'),

    // Module imports
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      ReactiveFormsModule,
      FormsModule,
      GoogleMapsModule,
      GalleryModule,

      // Angular Material
      MatDialogModule,
      MatNativeDateModule,
      MatDatepickerModule,
      MatSidenavModule,
      MatOptionModule,
      MatSelectModule,
      MatAutocompleteModule,
      MatCheckboxModule,
      MatSliderModule,

      // Others
      NgOptimizedImage
    )
  ]
};
